import { KeyChord } from "@/presentation/components/KeyCap";
import type { StripFrame } from "@/presentation/features/drill/keystroke-log";
import { LABELS } from "@/presentation/i18n/labels";
import "./KeystrokeStrip.css";

interface KeystrokeStripProps {
  readonly frames: readonly StripFrame[];
}

/**
 * 打鍵の帯（ui-design.md §5.4）。直近{@link STRIP_CAPACITY}打を、日本語（JIS）配列で
 * 実際に押した物理キーの形（`$` なら Shift + 4）で左から右へ流す。
 * 12打を超えた分は`keystroke-log.ts`側で既に落とされているため、渡された配列をそのまま描く。
 */
export function KeystrokeStrip({ frames }: KeystrokeStripProps) {
  return (
    <ul className="keystroke-strip" aria-label={LABELS.keystroke}>
      {frames.map((frame) => (
        <li className="keystroke-strip__frame" key={frame.id}>
          <KeyChord notation={frame.label} state={frame.state} />
        </li>
      ))}
    </ul>
  );
}
